import { IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, Min } from 'class-validator';
import {
  MICRONUTRIENT_CODES,
  type MicronutrientCode,
} from '../../nutrition/micronutrient-registry';
import {
  MICRONUTRIENT_SOURCE_TYPES,
  type MicronutrientSourceType,
} from './micronutrient-source-type.enum';

/**
 * One vitamin declared on a nutritional profile version (Allegato XIII Reg. UE
 * 1169/2011). `amountPer100g` is expressed in the nutrient's canonical unit
 * (mg or mcg, see `MICRONUTRIENT_REGISTRY`), never in grams: the unit is not a
 * free choice, it is derived from `nutrientCode`. Absence of a row for a code
 * means "unknown", never zero; an explicit zero is a declared row with value 0.
 */
export class MicronutrientInputDto {
  @IsEnum(MICRONUTRIENT_CODES)
  nutrientCode!: MicronutrientCode;

  @IsNumber()
  @Min(0)
  amountPer100g!: number;

  /**
   * Optional value guaranteed at the end of the product shelf life. For an
   * added vitamin this is the value used by the legal label calculation; the
   * production/analysis value above remains available for provenance.
   */
  @IsOptional()
  @IsNumber()
  @Min(0)
  declaredEndOfShelfLifePer100g?: number | null;

  @IsEnum(MICRONUTRIENT_SOURCE_TYPES)
  sourceType!: MicronutrientSourceType;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  sourceReference?: string | null;
}
